var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"content-convert",domProps:{"innerHTML":_vm._s(_vm.handleContent(_vm.content))},on:{"click":_vm.openTag}})
}
var staticRenderFns = []

export { render, staticRenderFns }